import React, { useContext, useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { CupStraw, PlusCircle, Snow, Tv, Wifi } from "react-bootstrap-icons";
import axios from "axios";
import Swal from "sweetalert2";
import "../../assets/css/vendors/HotelScreens/hotelRoom.css";
import VendorLayout from "../../layout/HotelVendorLayout/VendorLayout";
import RoomCard from "../../components/vendors/RoomCard";
import AddRoom from "../../components/vendors/AddRoom";
import AppContext from "../../context/AppContext";
import { useNavigate } from "react-router-dom";
const HotelRooms = () => {
  const { baseUrl, authToken, hotelId } = useContext(AppContext);
  const navigate = useNavigate();
  const getVendorId = () => {
    try {
      const token = authToken;
      if (token) {
        const payload = JSON.parse(atob(token.split(".")[1]));
        return payload.sub;
      }
    } catch (e) {}
    return localStorage.getItem("vendorId");
  };
  const vendorId = getVendorId();
  const [rooms, setRooms] = useState([]);
  const [totalRooms, setTotalRooms] = useState(0)
  const [showModal, setShowModal] = useState(false);
  const [editingItem, setEditingItem] = useState(null);
  const [loading, setLoading] = useState(false);
  const [hotelExists, setHotelExists] = useState(null);
  const [formData, setFormData] = useState({
    room_number: "",
    room_type: "",
    price: "",
    capacity: "",
    floor: "",
    status: "Available",
    amenities: "",
    images: [],
    imageFiles: [],
    existing_images: [],
    deleted_image_ids: [],
  });

  const getImageUrl = (path) => {
    if (!path) return "";
    if (path.startsWith("http")) return path;
    return `http://127.0.0.1:8000/storage/${path}`;
  };

  
  const fetchRooms = () => {
    return axios
      .get(`${baseUrl}/vendor/rooms/getAll`, {
        params: { vendor_id: vendorId },
        headers: { Authorization: `Bearer ${authToken}` },
      })
      .then((res) => {
        if (res.data.success) {
          const processedRooms = res.data.data.map((room) => ({
            ...room,
            images:
              room.jjroomimages?.map((img) => getImageUrl(img.image_path)) ||
              [],
            jjroomimages: room.jjroomimages || [],
          }));
          setRooms(processedRooms);
          setTotalRooms(res.data.total || 0); 
          setLoading(false);
            console.log(res.data.data);

          return processedRooms;
        }
        setLoading(false);
        return Promise.reject("Failed to fetch rooms");
      })
      .catch((err) => {
        console.log("Rooms fetch error:", err);
        setLoading(false);
        return Promise.reject(err);
      });
  };
  const handleAddRoom = () => {
    setEditingItem(null);
    setFormData({
      room_number: "",
      room_type: "",
      price: "",
      capacity: "",
      floor: "",
      status: "Available",
      amenities: "",
      images: [],
      imageFiles: [],
      existing_images: [],
      deleted_image_ids: [],
    });
    setShowModal(true);
  };

  const handleEditRoom = (room) => {
    setEditingItem(room);
    setFormData({
      room_number: room.room_number,
      room_type: room.room_type,
      price: room.price,
      capacity: room.capacity,
      floor: room.floor,
      status: room.status,
      amenities: Array.isArray(room.amenities)
        ? room.amenities.join(", ")
        : room.amenities || "",
      images: [],
      imageFiles: [],
      existing_images:
        room.jjroomimages?.map((img) => ({
          id: img.id,
          url: getImageUrl(img.image_path),
        })) || [],
      deleted_image_ids: [],
    });
    setShowModal(true);
  };

  const handleDeleteRoom = (roomId) => {
    Swal.fire({
      title: "Are you sure?",
      text: "This room will be deleted permanently.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading(true);

        axios
          .delete(`${baseUrl}/vendor/room/deleteRoom`, {
            data: { id: roomId },
            headers: { Authorization: `Bearer ${authToken}` },
          })
          .then((res) => {
            if (res.data.success) {
              return fetchRooms();
            } else {
              return Promise.reject(res.data.message || "Delete failed");
            }
          })
          .then(() => {
            Swal.fire("Deleted!", "Room deleted successfully!", "success");
            setLoading(false);
          })
          .catch((err) => {
            console.error("Delete error:", err);
            Swal.fire(
              "Error",
              err.response?.data?.message || "Something went wrong",
              "error"
            );
            setLoading(false);
          });
      }
    });
  };

  const handleSave = (e) => {
    e.preventDefault();

    if (!hotelId) {
      Swal.fire("Hotel Not Found", "Please register your hotel first.", "warning");
      return;
    }

    if (
      !formData.room_number ||
      !formData.room_type ||
      !formData.price ||
      !formData.capacity ||
      !formData.floor
    ) {
      Swal.fire("Validation Error", "Please fill all required fields", "warning");
      return;
    }

    setLoading(true);

    const formDataToSend = new FormData();
    formDataToSend.append("jjhotelregistration_id", hotelId);
    formDataToSend.append("room_number", formData.room_number);
    formDataToSend.append("room_type", formData.room_type);
    formDataToSend.append("price", formData.price);
    formDataToSend.append("capacity", formData.capacity);
    formDataToSend.append("floor", formData.floor);
    formDataToSend.append("status", formData.status);
    formDataToSend.append("amenities", formData.amenities || "");

    let url = `${baseUrl}/vendor/room/addRoom`;

    if (editingItem) {
      url = `${baseUrl}/vendor/room/updateRoom`;
      formDataToSend.append("id", editingItem.id);

      if (formData.deleted_image_ids && formData.deleted_image_ids.length > 0) {
        formDataToSend.append(
          "deleted_images",
          JSON.stringify(formData.deleted_image_ids),
        );
      }
    }

    if (formData.imageFiles && formData.imageFiles.length > 0) {
      formData.imageFiles.forEach((file) => {
        formDataToSend.append("room_images[]", file);
      });
    }

    axios
      .post(url, formDataToSend, {
        headers: {
          Authorization: `Bearer ${authToken}`,
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        if (res.data.success) {
          return fetchRooms();
        } else {
          return Promise.reject(res.data.message || "Something went wrong");
        }
      })
      .then(() => {
        setShowModal(false);
        setFormData({
          room_number: "",
          room_type: "",
          price: "",
          capacity: "",
          floor: "",
          status: "Available",
          amenities: "",
          images: [],
          imageFiles: [],
          existing_images: [],
          deleted_image_ids: [],
        });
        setEditingItem(null);
        Swal.fire(
          "Success",
          editingItem ? "Room updated successfully!" : "Room added successfully!",
          "success"
        );
        setLoading(false);
      })
      .catch((err) => {
        console.error("Save error:", err);
        Swal.fire(
          "Error",
          err.response?.data?.message || err.message || "Something went wrong",
          "error"
        );
        setLoading(false);
      });
  };

  const getHotelStatusClass = (status) => {
    switch (status) {
      case "Available":
        return "hotel-status-available";
      case "Booked":
        return "hotel-status-booked";
      case "Maintenance":
        return "hotel-status-maintenance";
      default:
        return "";
    }
  };

  const getAmenityIcon = (amenity) => {
    if (!amenity) return null;
    const amenityLower = amenity.toLowerCase();
    if (amenityLower.includes("wifi")) return <Wifi size={16} />;
    if (amenityLower.includes("ac")) return <Snow size={16} />;
    if (amenityLower.includes("tv")) return <Tv size={16} />;
    if (amenityLower.includes("minibar")) return <CupStraw size={16} />;
    return null;
  };

   useEffect(() => {
    if (!vendorId) return;

    if (!hotelId) {
      setHotelExists(false);
      setLoading(false);
      return;
    }

    setHotelExists(true);
    setLoading(true);
    fetchRooms().catch(() => {});
  }, [vendorId, hotelId]); 

  if (loading && rooms.length === 0) {
    return (
      <VendorLayout>
        <div className="text-center py-5">Loading...</div>
      </VendorLayout>
    );
  }

  return (
    <VendorLayout>
      <div className="hotel-rooms-container">
        <div className="hotel-screen-header">
          <div>
            <h3 className="hotel-screen-title">All Rooms</h3>
            <p className="hotel-screen-subtitle">
              Manage hotel rooms and their status
            </p>
          </div>
          <Button
            variant="primary"
            className="jjhotel-add-btn"
          onClick={() => {
             if (!hotelExists) {
               Swal.fire("Hotel Not Found", "Please register your hotel first.", "warning");
               navigate("/vendor/settings/hotel-settings");
               return;
             }
             if (rooms.length >= totalRooms) {
               Swal.fire("Limit Reached", `You can only add ${totalRooms} rooms.`, "warning");
               return;
             }
             handleAddRoom();
          }}
          >
            <PlusCircle size={20} className="me-2" />
            Add Room
          </Button>
        </div>

        <div className="hotel-rooms-grid">
          {rooms.map((room) => (
            <RoomCard
              key={room.id}
              room={room}
              getHotelStatusClass={getHotelStatusClass}
              getAmenityIcon={getAmenityIcon}
              onEdit={() => handleEditRoom(room)}
              onDelete={() => handleDeleteRoom(room.id)}
            />
          ))}
        </div>

        {rooms.length === 0 && !loading && (
          <div className="hotel-empty-state">
            <p className="text-muted">
              No rooms found. Add your first room to get started.
            </p>
          </div>
        )}
      </div>

      <AddRoom
        showModal={showModal}
        setShowModal={setShowModal}
        editingItem={editingItem}
        formData={formData}
        setFormData={setFormData}
        handleSave={handleSave}
        loading={loading}
      />
    </VendorLayout>
  );
};
export default HotelRooms;